import { makeV2APIURL } from '^/store/duck/API';
import { useReactQuery } from '^/utilities/api';
import * as T from '^/types';
import { APIToPermission } from '^/store/react-query/permission';

export const permissionListQueryKey = 'project-permissions';

export const PermissionListQueryKeys = {
  getPermission: (projectId = '') => [permissionListQueryKey, projectId],
};

export const useGetPermissions = ({
  projectId = '',
  isDisabled = false,
}: {
  projectId?: string;
  isDisabled?: boolean;
}) => {
  const url = projectId ? makeV2APIURL('projects', projectId, 'permissions') : '';

  const {
    refetch,
    isLoading,
    data: permissionData,
  } = useReactQuery({
    endpoint: url,
    axiosOptions: {},
    staleTime: 0,
    queryKey: PermissionListQueryKeys.getPermission(projectId),
    enabled: Boolean(projectId && !isDisabled),
  });
  const apiPermissions: T.APIPermission[] | undefined = permissionData?.data;
  const permissions: T.Permission[] | undefined = apiPermissions?.map(permission =>
    APIToPermission(Number(projectId), permission)
  );

  return { permissions, isLoading, refetch };
};
